import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import IGetCatalogItemsDTO from "../../../models/DTO/IGetCatalogItemsDTO";
import IOnGetCatalogItemsDTO from "../../../models/DTO/IOnGetCatalogItemsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IDraftOrderItem from "../../../models/IDraftOrderItem";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import SupplierService from "../../../services/SupplierService";
import UserService from "../../../services/UserService";
import VendorService from "../../../services/VendorService";
import { LoadingResults } from "../../shared/LoadingResults/LoadingResults";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import "./CommonItemsModal.scss";
import OwS3ImageViewer from "../../shared/OwS3ImageViewer/OwS3ImageViewer";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { IAddBulkItems } from "@models/IAddBulkItems";
import INewOrder_ItemUI from "@models/INewOrder_ItemUI";

type Props = {
    socket: Socket;
    catalogGuid: string;
    addItemsFn: (items: IAddBulkItems[]) => void;
    closeFn: () => void;
};

type State = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    queryString: string;
    catalogItems: ICatalog_Item[];
    selectedGuids: string[];
    modalIsOpen: boolean;
    isLoading: boolean;
};

class CommonItemsModal extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    readonly state: State = {
        userModel: UserService.getLocalUserDataFn(),
        supplierModel: SupplierService.getLocalSupplierDataFn(),
        vendorModel: VendorService.getLocalVendorDataFn(),
        queryString: "?is_common_item=true",
        selectedGuids: [],
        catalogItems: [],
        modalIsOpen: true,
        isLoading: true,
    };

    constructor(props: Props) {
        super(props);

        this.sockets = [{ endpoint: EndpointsEnum.CatalogItemOnGetCatalogItems, fn: this.onGetCatalogItems }];
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        this.getCatalogItems();
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    getCatalogItems = () => {
        const payload: IGetCatalogItemsDTO = {
            userGuid: this.state.userModel.guid,
            userToken: this.state.userModel.token,
            supplierGuid: this.state.supplierModel.guid,
            catalogGuid: this.props.catalogGuid,
            limit: 100,
            offset: 0,
            queryString: this.state.queryString,
        };

        if (!this.state.userModel.isSupplierUser) {
            payload.vendorGuid = this.state.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.CatalogItemGetCatalogItems, payload);
    };

    onGetCatalogItems = (data: IOnGetCatalogItemsDTO) => {
        this.setState({
            catalogItems: data.catalog_items,
            isLoading: false,
        });
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const { selectedGuids } = this.state;

        let isFound = false;
        let foundIndex = 0;

        for (let index = 0; index < selectedGuids.length; ++index) {
            const guid = selectedGuids[index];
            if (guid === name) {
                isFound = true;
                foundIndex = index;
            }
        }

        if (!isFound && value) {
            selectedGuids.push(name);
        }

        if (isFound && !value) {
            selectedGuids.splice(foundIndex, 1);
        }

        this.setState({
            selectedGuids,
        });
    };

    saveSelectedGuids = () => {
        const catalogItems: IAddBulkItems[] = [];

        for (const guid of this.state.selectedGuids) {
            for (const item of this.state.catalogItems) {
                if (item.guid === guid) {
                    const draftItem: INewOrder_ItemUI = {
                        Catalog_Item: item,
                        qty: 1,
                        catalog_item_id: item.id,
                        item_no: 0, // TODO does this need to be set?
                    };

                    catalogItems.push({ item: draftItem });
                }
            }
        }

        this.props.addItemsFn(catalogItems);
        this.props.closeFn();
    };

    afterOpenModal = () => {};

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    };

    render() {
        return (
            <div className="CommonItemsModal">
                <div className={"d-flex w-100 justify-content-end"}>
                    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.props.closeFn} />
                </div>
                <div>
                    <OwTitle leftIconName={"fad fa-cubes"} title={"common_items"} tag={"h3"} />
                    <p className={"text-muted"}>
                        <OwTranslate defaultMessage={"what_are_common_items"} id={"what_are_common_items"} />
                    </p>
                </div>
                {this.state.isLoading ? (
                    <div className={"mt-3 mb-3"}>
                        <LoadingResults />
                    </div>
                ) : null}
                {this.state.catalogItems.map((item: ICatalog_Item, index: number) => {
                    let isChecked = false;

                    for (const selectedGuid of this.state.selectedGuids) {
                        if (selectedGuid === item.guid) {
                            isChecked = true;
                        }
                    }

                    return (
                        <div key={index} className={"d-flex align-items-center"} style={{ height: "3rem" }}>
                            <OwCheckbox
                                skipTranslate={true}
                                label={`${item.name}`}
                                name={item.guid}
                                fn={this.handleChange}
                                checked={isChecked}
                            />
                            {/*<OwS3ImageViewer className={'ms-3'} isMicroView={true} imageIndex={0} imageSeq={1} catalogItem={item}/>*/}
                        </div>
                    );
                })}
                <OwButton fn={this.saveSelectedGuids} title={"continue"} className={"btn-primary me-2"} />
                <OwButton fn={this.props.closeFn} title={"cancel"} className={"btn-danger"} />
            </div>
        );
    }
}

export default CommonItemsModal;
